import {ComponentRegistry} from '@enonic/react-components'
import {DefaultPage} from './components/pages/DefaultPage'
import {RichTextPart} from './components/rich-text/RichText'
import {InfoBox} from './components/info-box/InfoBox'
import {Feature} from './components/feature/Feature'
import {KeyInfo} from './components/key-info/KeyInfo'
import {Testimonial} from './components/testimonial/Testimonial'
import {KeyFigures} from './components/key-figures/KeyFigures'
import {AccordionList} from './components/accordion-list/AccordionList'
import {NewsListFeatured} from './components/news-list-featured/NewsListFeatured'
import {PersonList} from './components/person-list/PersonList'
import {News} from './components/news/News'
import {Person} from './components/person/Person'
import {Education} from './components/education/Education'
import {InfoPage} from './components/info-page/InfoPage'
import {Search} from './components/search/Search'
import {Contacts} from './components/contacts/Contacts'
import {ContentList} from './components/content-list/ContentList'
import {OmvendtUndervisning} from './components/omvendt-undervisning/OmvendtUndervisning'
import {AdmissionByLocation} from './components/admission-by-location/AdmissionByLocation'
import {Snarveier} from './components/snarveier/Snarveier'

export const componentRegistry = new ComponentRegistry()

componentRegistry.addPage('no.diakonova.fagskolen:default', {View: DefaultPage})

componentRegistry.addPart('no.diakonova.fagskolen:rich-text', {View: RichTextPart})
componentRegistry.addPart('no.diakonova.fagskolen:info-box', {View: InfoBox})
componentRegistry.addPart('no.diakonova.fagskolen:feature', {View: Feature})
componentRegistry.addPart('no.diakonova.fagskolen:key-info', {View: KeyInfo})
componentRegistry.addPart('no.diakonova.fagskolen:testimonial', {View: Testimonial})
componentRegistry.addPart('no.diakonova.fagskolen:key-figures', {View: KeyFigures})
componentRegistry.addPart('no.diakonova.fagskolen:accordion-list', {View: AccordionList})
componentRegistry.addPart('no.diakonova.fagskolen:news-list-featured', {View: NewsListFeatured})
componentRegistry.addPart('no.diakonova.fagskolen:person-list', {View: PersonList})
componentRegistry.addPart('no.diakonova.fagskolen:news-hero', {View: News})
componentRegistry.addPart('no.diakonova.fagskolen:person-hero', {View: Person})
componentRegistry.addPart('no.diakonova.fagskolen:education-hero', {View: Education})
componentRegistry.addPart('no.diakonova.fagskolen:info-page-hero', {View: InfoPage})
componentRegistry.addPart('no.diakonova.fagskolen:search-hero', {View: Search})
componentRegistry.addPart('no.diakonova.fagskolen:contacts', {View: Contacts})
componentRegistry.addPart('no.diakonova.fagskolen:content-list', {View: ContentList})
componentRegistry.addPart('no.diakonova.fagskolen:omvendt-undervisning', {View: OmvendtUndervisning})
componentRegistry.addPart('no.diakonova.fagskolen:admission-by-location', {View: AdmissionByLocation})
componentRegistry.addPart('no.diakonova.fagskolen:snarveier', {View: Snarveier})
